
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dr/[name]",
      function () {
        return require("private-next-pages/dr/[name].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dr/[name]"])
      });
    }
  